import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';
import {
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { Flex } from '@aloft/toolkit-sui';
import { computeTrend } from '../../utils/computeTrend.ts';
import { Typography } from '../../../../summary/components/Typography.tsx';


export const MedianDOM = ({
  data,
  disableAnimations = false,
}: {
  data: AbodeAggregateMarketConditions;
  disableAnimations?: boolean;
}) => {
  const chartData: {
    month: string;
    medianDaysOnMarket: number;
  }[] = data.monthlyData.filter((item) => item.median_days_on_market !== null).map((item => ({
    month: item.month.substring(0, 7),
    medianDaysOnMarket: item.median_days_on_market ?? 0,
  })));
  const maxValue = Math.max(...chartData.map(item => item.medianDaysOnMarket));
  const trendSeries = computeTrend(chartData, 'medianDaysOnMarket');
  const trendSeriesColor =
    (trendSeries[trendSeries.length - 1] || { medianDaysOnMarket: 0 }).medianDaysOnMarket >= (trendSeries[0] || { medianDaysOnMarket: 0 }).medianDaysOnMarket
      ? '#FF0000'
      : '#00B050';

  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="1400px"
    >
      <Typography variant="h3">Median Comp. Sale DOM</Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={chartData}
          margin={{ top: 80, right: 40, left: 0, bottom: 0 }}
        >
          <YAxis domain={[0, maxValue]} tick={false} axisLine={false} />
          <XAxis dataKey="month" interval={0} fontSize={12} tickLine={false} />
          <Line type="linear" dataKey="medianDaysOnMarket" stroke="#3455DB" strokeWidth={2} dot={{ r: 3 }} isAnimationActive={!disableAnimations} >
            <LabelList dataKey="medianDaysOnMarket" position="top" fontSize={12} offset={10} />
          </Line>
          <Line type="linear" data={trendSeries} dataKey="medianDaysOnMarket" stroke={trendSeriesColor} strokeWidth={1} dot={false} strokeDasharray="5 5" isAnimationActive={!disableAnimations} />
        </LineChart>
      </ResponsiveContainer>
    </Flex >
  );
}
